export default __webpack_public_path__ + "static/media/profile-yudha.5f94499a.png";